// angular
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  ViewChild,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// components
import { ButtonComponent } from '../button/button.component';
// services
import { UserService } from '@app/shared/services/user.service';
// types
import { MenuButtons } from '@app/layout/shared/types/menu-buttons.type';

@Component({
  selector: 'pwj-buttons-menu',
  standalone: true,
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './buttons-menu.component.html',
  styleUrl: './buttons-menu.component.scss',
})
export class ButtonsMenuComponent {
  public isShowMenu: boolean = false;
  public selectedLang!: string;

  // inputs
  menuText = input.required<string>();
  menuIcon = input<string>();
  menuItems = input.required<MenuButtons[]>();
  // outputs
  onValueChange = output<string>();

  // get toggle menu button element
  @ViewChild('toggleButton', { static: true, read: ElementRef })
  public toggleButton!: ElementRef;

  // dependencies
  private readonly _translateService = inject(TranslateService);
  private readonly _userService = inject(UserService);
  constructor() {}

  public toggleMenu() {
    this.isShowMenu = !this.isShowMenu;
  }

  public setMenuValue(option: string) {
    this.onValueChange.emit(option);
    // close menu
    this.toggleMenu();
  }

  @HostListener('document:click', ['$event'])
  // detect when click out of the menu
  clickOut(event: Event) {
    if (
      this.isShowMenu &&
      !this.toggleButton.nativeElement?.contains(event.target)
    ) {
      this.isShowMenu = false;
    }
  }
}
